import { configureStore } from '@reduxjs/toolkit';
import { createTransform } from 'redux-persist';
import createSagaMiddleware from 'redux-saga';
import rootSaga from './sagas';
import { persistReducer, persistStore } from 'redux-persist';
import { rootReducer } from '../Reducers';
// import {
//   GET_MARKET_CONFIG_CONTENT,
//   GET_CONTENT,
//   GET_MORE_CONTENT,
//   SYNC_CONTENTFUL_DATA,
//   GET_I18N_CONTENT,
// } from '../../constants';
let persistanceStorage = null;
let store = null;
const DEFAULT_REDUCERS_WHITELISTED = [
    'appStateReducer',
    'appUpdateReducer',
    'authReducer',
    'cartReducer',
    'storesReducer',
    'placesAutocompleteReducer',
    'profileReducer',
];
// const IGNORED_ACTION_TYPES = [
//   'Contentful/fetch',
//   GET_MARKET_CONFIG_CONTENT,
//   GET_CONTENT,
//   GET_MORE_CONTENT,
//   SYNC_CONTENTFUL_DATA,
//   GET_I18N_CONTENT,
// ];
const sagaMiddleware = createSagaMiddleware();
export const transformData = (inboundState, key) => {
    if (key === 'profileReducer') {
        if (inboundState.hasOwnProperty('menuResponse')) {
            delete inboundState['menuResponse'];
        }
        if (inboundState.hasOwnProperty('flatResponse')) {
            delete inboundState['flatResponse'];
        }
        return inboundState;
    }
    else {
        return inboundState;
    }
};
const blacklistTransform = createTransform((inboundState, key) => transformData(inboundState, key));
const newStore = (storage = {}, enhancer = null, reducersWhitelist = []) => {
    persistanceStorage = storage;
    const whitelist = [...DEFAULT_REDUCERS_WHITELISTED, ...reducersWhitelist];
    const persistedReducer = persistReducer({
        key: 'root',
        storage: storage,
        whitelist,
        transforms: [blacklistTransform],
    }, rootReducer);
    const options = {
        reducer: persistedReducer,
        devTools: process.env.NODE_ENV !== 'production',
        middleware: (getDefaultMiddleware) => getDefaultMiddleware({
            immutableCheck: false,
            serializableCheck: false,
            // serializableCheck: {
            //   ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER, ...IGNORED_ACTION_TYPES],
            // },
        }).concat(sagaMiddleware),
    };
    store = configureStore(options);
    if (enhancer) {
        options.enhancers = [enhancer];
    }
    const persistor = persistStore(store);
    sagaMiddleware.run(rootSaga);
    return { store, persistor };
};
export { newStore, store, persistanceStorage };
